import { FrameRange } from 'content-creation-common/models';
import VideoFile from '../models/VideoFile';
import Resolution from './Resolution';

export class FrameProviderPrioritizationInterface {
  _videoFile;

  _unavailableFrameRanges;

  static identifier = 'FrameProviderPrioritization';

  /**
   * @constructor
   * @param  {VideoFile} videoFile
   * @param  {List<FrameRange>} unavailableFrameRanges
   * @return {FrameProviderPrioritizationInterface}
   */
  constructor(videoFile, unavailableFrameRanges) {
    if (!VideoFile.isVideoFile(videoFile)) {
      throw new Error(
        `${FrameProviderPrioritizationInterface.name} was not initialized with correct params`,
      );
    }
    this._videoFile = videoFile;
    this._unavailableFrameRanges = unavailableFrameRanges;
  }

  /**
   * @typedef {Object} FrameProviderPrioritizationTransferrable
   * @param  {FrameProviderPrioritizationInterface.identifier} type
   * @param  {PlainVideoFile} videoFile
   * @param  {List<FrameRange>} unavailableFrameRanges
   * @param  {String} requestedResolutionName
   */

  /**
   * @function createTransferrable
   * @return {FrameProviderPrioritizationTransferrable}
   */
  static createTransferrable(
    videoFile,
    unavailableFrameRanges,
    requestedResolution,
  ) {
    const unavailableFrameRangesJSON = [];
    unavailableFrameRanges.forEach((frameRange) => {
      unavailableFrameRangesJSON.push(frameRange.toJSON());
    });
    return {
      type: FrameProviderPrioritizationInterface.identifier,
      videoFile: VideoFile.toPlainObject(videoFile),
      unavailableFrameRanges: unavailableFrameRangesJSON,
      requestedResolutionName: requestedResolution.name,
    };
  }

  /**
   * @function fromTransferrable
   * @param  {FrameProviderPrioritizationTransferrable} frameProviderPrioritizationTransferrable
   * @return {FrameProviderPrioritizationInterface}
   */
  static fromTransferrable(frameProviderPrioritizationTransferrable) {
    const frameRanges = [];
    frameProviderPrioritizationTransferrable.unavailableFrameRanges.forEach(
      (frameRange) => {
        frameRanges.push(FrameRange.fromJSON(frameRange));
      },
    );
    return new FrameProviderPrioritizationInterface(
      VideoFile.fromPlainObject(
        frameProviderPrioritizationTransferrable.videoFile,
      ),
      frameRanges,
      new Resolution(
        frameProviderPrioritizationTransferrable.requestedResolutionName,
      ),
    );
  }

  /**
   * @function videoFile
   * @return {VideoFile}
   */
  get videoFile() {
    return this._videoFile;
  }

  /**
   * @function {function name}
   * @return {Array<FrameRange>} {description}
   */
  get unavailableFrameRanges() {
    return this._unavailableFrameRanges;
  }
}
